import { Navigate, useParams } from 'react-router-dom';
import {
  AttendancePage as SharedAttendancePage,
  DEFAULT_ATTENDANCE_SLUG,
  attendanceTabBySlug,
} from '@trinetra/shared';
import { useNode } from '../contexts/NodeContext';

/**
 * `/attendance/:tab` — one page per attendance surface. Data is node-scoped: the
 * cloud adapter binds the selected node, so switching node refetches via `nodeKey`.
 */
export default function AttendancePage() {
  const { tab } = useParams();
  const { selectedNode } = useNode();
  const nodeId = selectedNode?.nodeId || '';

  if (!attendanceTabBySlug(tab)) {
    return <Navigate to={`/attendance/${DEFAULT_ATTENDANCE_SLUG}`} replace />;
  }

  return (
    <SharedAttendancePage
      key={`${nodeId}:${tab}`}
      slug={tab}
      nodeKey={nodeId}
      emptyState={
        nodeId ? undefined : <div className="text-muted-foreground">Select a site to view attendance.</div>
      }
    />
  );
}
